import React from 'react';
import { Link } from 'react-router-dom';
import { Crown, Shirt, Coffee, Briefcase, Sparkles } from 'lucide-react';
import { categories } from '../data/mockData';

const iconMap = {
  crown: Crown,
  shirt: Shirt,
  coffee: Coffee,
  briefcase: Briefcase,
  sparkles: Sparkles
};

const CategoryCard = ({ category }) => {
  const IconComponent = iconMap[category.icon] || Crown;
  
  return (
    <Link
      to={`/shop?category=${category.slug}`}
      className="group relative block rounded-xl overflow-hidden aspect-square"
    >
      {/* Background Image */}
      <img
        src={category.image}
        alt={category.name}
        className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
      />
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-gray-900/90 via-gray-900/40 to-transparent" />
      
      {/* Content */}
      <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
        <div className="flex items-center gap-3 mb-2">
          <IconComponent className="w-5 h-5 text-amber-400" />
          <h3 className="font-serif text-xl md:text-2xl font-bold text-white italic">
            {category.name}
          </h3>
        </div>
        <p className="text-gray-300 text-sm">
          {category.description}
        </p>
      </div>
    </Link>
  );
};

const CategoriesSection = () => {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-14">
          <span className="text-amber-600 font-semibold text-sm tracking-wider uppercase">
            Browse By
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mt-3">
            Categories
          </h2>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* First row - 4 items */}
          {categories.slice(0, 4).map((category) => (
            <CategoryCard key={category.id} category={category} />
          ))}
        </div>
        
        {/* Second row - 1 item (Custom Orders) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
          {categories.slice(4).map((category) => (
            <CategoryCard key={category.id} category={category} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
